import React from 'react';
import Grid from '@mui/material/GridLegacy';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, FormControl, Select, MenuItem, FormHelperText } from '@mui/material';
import { DIALOG_CONTENT_SX } from '../../../theme';

export default function TagDialog({
  open,
  onClose,
  form,
  setForm,
  onSave,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3, boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)' } }}
    >
      <DialogTitle sx={{
        background: 'linear-gradient(135deg, #a855f7 0%, #ec4899 100%)',
        color: 'white',
        fontWeight: 700,
        py: 3,
        px: 4
      }}>
        {form._id ? 'Edit Tag' : 'Create New Tag'}
      </DialogTitle>
      <DialogContent sx={DIALOG_CONTENT_SX}>
        <Grid container spacing={3} sx={{ pt: 1 }}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Tag Name"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              placeholder="e.g. Hidden Gem, Cozy, Pet Friendly"
              required
              helperText="Display name (e.g. Hidden Gem, Cozy)"
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Slug (optional)"
              value={form.slug}
              onChange={(e) => setForm({ ...form, slug: e.target.value })}
              placeholder="e.g. hidden-gem, cozy"
              helperText="Lowercase, hyphens. Auto-generated from name if empty."
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}>
              <Select
                label="Tag Type"
                value={form.tagType || 'vibe'}
                onChange={(e) => setForm({ ...form, tagType: e.target.value })}
                displayEmpty
              >
                <MenuItem value="vibe">Vibe (Primary Tag & Vibe Tags)</MenuItem>
                <MenuItem value="famous">Famous (Famous Tag only, e.g. Hidden Gem, Trending)</MenuItem>
              </Select>
              <FormHelperText>Vibe tags appear in Primary Tag and Vibe Tags dropdowns. Famous tags appear only in the Famous Tag dropdown for places.</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              rows={2}
              label="Description (Optional)"
              value={form.description}
              onChange={(e) => setForm({ ...form, description: e.target.value })}
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Sort Order"
              type="number"
              value={form.sortOrder}
              onChange={(e) => setForm({ ...form, sortOrder: parseInt(e.target.value) || 0 })}
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ p: 3, bgcolor: 'rgba(0, 0, 0, 0.02)' }}>
        <Button onClick={onClose} sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 500, px: 3 }}>Cancel</Button>
        <Button
          variant="contained"
          onClick={onSave}
          disabled={!form.name?.trim()}
          sx={{
            background: 'linear-gradient(135deg, #a855f7 0%, #ec4899 100%)',
            boxShadow: '0 4px 15px rgba(168, 85, 247, 0.4)',
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 500,
            px: 3,
            '&:hover': {
              background: 'linear-gradient(135deg, #ec4899 0%, #a855f7 100%)',
              boxShadow: '0 6px 20px rgba(168, 85, 247, 0.5)'
            },
            '&:disabled': { background: 'rgba(0, 0, 0, 0.12)' }
          }}
        >
          {form._id ? 'Update Tag' : 'Create Tag'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
